// extracted by mini-css-extract-plugin
export default {"input":"Checkbox_input__4gr9Q"};